import { Grid, IconButton, Tooltip, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import InfoIcon from "@material-ui/icons/Info";
import { ERowStatus } from "api/enums";

import { ContractRowStore, ContractStore } from "store";

export const CellDescription = ({ rowIndex, rowData, data }) => {
  const { code, description, expanded, isStage } = rowData;

  const handleExpandClick = (index, code) => () => {
    ContractRowStore.toggleChildrenRow(index, code);
  };

  return (
    <Tooltip title={description}>
      <Typography variant="inherit">
        {isStage && (
          <IconButton
            style={{ padding: 0, marginRight: 5 }}
            onClick={handleExpandClick(rowIndex, code)}
          >
            {expanded ? <ArrowRightIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        )}
        {description}
      </Typography>
    </Tooltip>
  );
};

export const CellTooltip = ({ data }) => (
  <Tooltip title={data}>
    <Typography variant="inherit">{data}</Typography>
  </Tooltip>
);

export const CellAction = ({ rowIndex, rowData }) => {
  const { status } = rowData;
  if (status === ERowStatus.UNCHAGED) return <></>;

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <IconButton
        title={"Informação"}
        style={{ padding: 0 }}
        onClick={() => {
          ContractStore.openLineHistoryMenu();
          ContractRowStore.selectRowByIndex(rowIndex);
        }}
      >
        <InfoIcon style={{ fontSize: "1.25rem" }} />
      </IconButton>
    </Grid>
  );
};
